import { timeWarningHandler } from './timeWarningHandler'
import { screenChallengeHandler } from './screenChallengeHandler'
import { stateChangeHandler } from './stateChangeHandler'
import { studentRejoinHandler } from './studentRejoinHandler'
import { discussionAnalyzed } from './discussionAnalyzed'
import { collaborationCalculationScore } from './collaborationCalculationScore'

export const EVENT_TYPES = {
  TIME_WARNING: 'time-warning',
  STATE_CHNAGE: "state_change",
  STUDENT_REJOIN: "student_rejoin",
  DISCUSSION_ANALYZED: "discussion_analyzed",
  COLLABORATION_CALCULATION_SCORE: "collaboration_calculation_score"
}

export const dataTrackHandlers = ({
  dataTrackEvent,
  timeTrack,
  setTimerValue,
  setTimeTrack,
  setIsShowRequestMoreTimeButton,
  setIsMoreTimeRequested,
  surveyTimeoutRef,
  isSessionCompleteRef,
  setIsShowTransitionView,
  clearTimeout,
  handleStateChange,
  setDiscussionAnalysis,
  setIsAnalysisLoading,
  setShowDiscussionAnalyzed,
  hasAnalysisDataRef,
  setCollaborationTip,
  sessionContext,
  hasSurvey,
  setAnnouncePhase,
}) => {
  timeWarningHandler({
    dataTrackEvent,
    timeTrack,
    setTimerValue,
    setTimeTrack,
    setIsShowRequestMoreTimeButton,
    setIsMoreTimeRequested,
  })

  screenChallengeHandler({
    surveyTimeoutRef,
    isSessionCompleteRef,
    setIsShowTransitionView,
    event: dataTrackEvent
  })

  stateChangeHandler({ event: dataTrackEvent, handleStateChange });

  studentRejoinHandler({
    event: dataTrackEvent,
    clearTimeout,
    surveyTimeoutRef,
    setIsShowTransitionView,
    handleStateChange,
    hasSurvey,
    setAnnouncePhase,
  })

  collaborationCalculationScore({
    dataTrackEvent,
    setDiscussionAnalysis,
    setIsAnalysisLoading,
    setShowDiscussionAnalyzed,
    hasAnalysisDataRef,
    sessionContext,
  })

  discussionAnalyzed({
    dataTrackEvent,
    setDiscussionAnalysis,
    setIsAnalysisLoading,
    setShowDiscussionAnalyzed,
    hasAnalysisDataRef,
    setCollaborationTip,
    sessionContext,
  })
}
